import { useField } from 'formik'
import React, { useEffect, useRef } from 'react'
import { Form, Radio } from 'semantic-ui-react'
import { SelectItem } from '../../models/SelectIem'
import FWOLabel from './FWOLabel'

interface Props {
  name: string
  options: SelectItem[]
  label?: string
  required: boolean
  tooltip?: string
  htmlTooltip?: string
  defaultHtmlTooltipIconText?: string
  showreadonly?: boolean
  clearSelection?: boolean
  onSelection?: (any) => void
}

const FWORadioSelectInput = (props: Props) => {
  const mountedRef = useRef(false)
  const [field, meta, helper] = useField(props.name)
  const hasError =
    meta.touched && (field.value != null || field.value != '') && meta.error
  useEffect(() => {
    mountedRef.current = true
    if (
      mountedRef.current &&
      props.clearSelection !== undefined &&
      props.clearSelection === true
    ) {
      helper.setValue('')
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.clearSelection])

  return (
    <>
      <div className="field">
        <FWOLabel
          label={props.label}
          name={props.name}
          tooltip={props.tooltip}
          htmlTooltip={props?.htmlTooltip}
          defaultHtmlTooltipIconText={props?.defaultHtmlTooltipIconText}
          required={props.required}
        />
        {hasError ? (
          <span className="validation-error">{meta.error}</span>
        ) : null}
        <Form.Field>
          {props.options?.map((option, index) => (
            <Radio
              key={index}
              label={option.text}
              name={props.name}
              value={option.value}
              checked={field.value === option.value}
              onChange={(e, d) => {
                helper.setValue(d.value)
                if (props.onSelection) {
                  props?.onSelection(d.value)
                }
              }}
              {...{ readOnly: props.showreadonly == true }}
            />
          ))}
        </Form.Field>
      </div>
    </>
  )
}

export default FWORadioSelectInput
